import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {SagaIterator} from 'redux-saga';
import {call, put, takeLatest} from 'redux-saga/effects';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';
import {ActionType} from 'types/reducers';

import {
    setAddressesSameness,
    startSetAddressesSamenessSaga,
} from '../../reducers/deliveryStep/billingAndShippingIsSame/billingAndShippingIsSame';

import {getOrderReviewTotals as getOrderReviewTotalsRequest} from '../../reducers/orderReviewTotals/orderReviewTotals';
import {setAddressFieldValue} from '../../reducers/sagaStep/sagaStep';

import {updateFieldValueSaga} from './updateFieldValueSaga/updateFieldValueSaga';
import {updateOrderReviewShippingInfoSaga} from './updateOrderReviewShippingInfoSaga/updateOrderReviewShippingInfoSaga';

/**
 * Updates addresses sameness status and evens addresses in store
 * @param {ActionType<boolean>} action - Received actual status of addresses sameness
 */
export function* setAddressesSamenessSaga({
    payload: isAddressesSame,
}: ActionType<boolean>): SagaIterator {
    yield put(setAddressesSameness(isAddressesSame));

    yield call(sendDesktopAnalyticsEvent, CHECKOUT_DELIVERY_STEP, {
        message: isAddressesSame
            ? 'Same Billing And Shipping - Checkbox'
            : 'Different Billing And Shipping - Checkbox',
    });
}

/**
 * Begin of saga
 */
export function* checkoutDeliveryStepFormsSaga(): SagaIterator {
    yield takeLatest(`${setAddressFieldValue}`, updateFieldValueSaga);
    yield takeLatest(`${startSetAddressesSamenessSaga}`, setAddressesSamenessSaga);
    yield takeLatest(
        [`${getOrderReviewTotalsRequest.fulfilled}`],
        updateOrderReviewShippingInfoSaga,
    );
}
